import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalSoftUpdateComponent } from './modal-soft-update.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalSoftUpdateComponent],
  exports: [ModalSoftUpdateComponent],
  providers: [],
})
export class ModalSoftUpdateModule {}
